import React, { useState, useContext } from "react";
import ProjectPresention from "./GameProjectPresention";
import { StateContext } from "../context/StateContextP";
import ProjectDetails from "./ProjectDetails";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import "../style/Transitions.css"; // Import your CSS file for transitions

const ProjectPresentionDisplay = () => {
  const { gameInfo } = useContext(StateContext);
  const [selectedProject, setSelectedProject] = useState(null);

  const showProjectDetails = (project) => {
    setSelectedProject(project);
  };

  const goBack = () => {
    setSelectedProject(null);
  };

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={selectedProject ? "details" : "list"}
        classNames="swipe"
        timeout={500}
      >
        {selectedProject ? (
          <ProjectDetails project={selectedProject} goBack={goBack} />
        ) : (
          <div>
            {gameInfo.map((info, i) => {
              return (
                <div key={i} onClick={() => showProjectDetails(info)}>
                  <ProjectPresention
                    img={info.img}
                    gameTitle={info.gameTitle}
                    gameDescription={info.gameDescription}
                    genre={info.genre}
                    engine={info.engine}
                    platfrom={info.platform}
                  />
                </div>
              );
            })}
          </div>
        )}
      </CSSTransition>
    </SwitchTransition>
  );
};

export default ProjectPresentionDisplay;